import * as React from 'react';

export const SeparatorField: React.FC = () => <hr style={{width: '100%'}}/>
